import Cache from './cache'

export default Cache
export * from './cache'
export { default as useCache } from './useCache'
